// extracted by mini-css-extract-plugin
export default {"title":"cart-form_title__DJ2jv","form":"cart-form_form__SSC6B","date":"cart-form_date__0tYWs","textarea":"cart-form_textarea__9MUuS"};